
import axios from '@/axios.js'
import url from '@/url.js'

export default {
  getVersionUpdate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/version`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_TOTAL', res.data.recordsTotal)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudVersionUpdate({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/version`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
}
